import { Fragment, ReactNode } from 'react';
import type { UIMessage } from '@tanstack/ai-react';

import { MarkdownPart } from './MarkdownPart';
import { UnsupportedPart } from './UnsupportedPart';

type MessagePart = UIMessage['parts'][number];
type PartType = MessagePart['type'];
type PartRenderer<Type extends PartType> = (part: Extract<MessagePart, { type: Type }>) => ReactNode;
type PartRenderers = { [Type in PartType]?: PartRenderer<Type> };

export const PART_RENDERERS: PartRenderers = {
  subagent: () => null,
  text: part => <MarkdownPart content={part.content} />,
  thinking: () => null,
  'tool-call': () => null,
  'tool-result': () => null,
};

const rendererOf = <Type extends PartType>(type: Type): PartRenderer<Type> | undefined => PART_RENDERERS[type];

export const renderPart = (part: MessagePart): ReactNode => {
  const render = rendererOf(part.type);

  return render ? render(part) : <UnsupportedPart />;
};

const keyedParts = ({ id, parts }: UIMessage) => parts.map((part, position) => ({ key: `${id}-${position}`, part }));

export const renderParts = (message: UIMessage) =>
  keyedParts(message).map(({ key, part }) => <Fragment key={key}>{renderPart(part)}</Fragment>);
